var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueCheckedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4.625C0.5 2.41586 2.29086 0.625 4.5 0.625H20.5C22.7091 0.625 24.5 2.41586 24.5 4.625V20.625C24.5 22.8341 22.7091 24.625 20.5 24.625H4.5C2.29086 24.625 0.5 22.8341 0.5 20.625V4.625Z",
    fill: "#4C6EF5",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7558 7.86908C20.0813 8.19451 20.0813 8.72215 19.7558 9.04759L11.4225 17.3809C11.0971 17.7064 10.5694 17.7064 10.244 17.3809L6.07733 13.2143C5.75189 12.8888 5.75189 12.3612 6.07733 12.0357C6.40277 11.7103 6.9304 11.7103 7.25584 12.0357L10.8333 15.6132L18.5773 7.86908C18.9028 7.54364 19.4304 7.54364 19.7558 7.86908Z",
    fill: "#4C6EF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCheckedIcon);
export default __webpack_public_path__ + "static/media/BlueCheckedIcon.3af1da49e36dd04a119ef732b1c529b6.svg";
export { ForwardRef as ReactComponent };